<template>
  <div class="index">
    <index-section
      class="info"
      v-for="(column, index) in infoColumns"
      :key="index"
      :title="column.title"
    >
      <table-like-area
        class="info-container"
        :label-width="column.labelWidth"
        :columns="column.data"
      ></table-like-area>
    </index-section>
  </div>
</template>

<script>
import { reqFetchRedisInfo } from '@/api/redis';
import IndexSection from '@/views/common/IndexSection';
import TableLikeArea from '@/views/common/TableLikeArea';
import { ss } from '@/utils/storage';

export default {
  name: 'Index',

  components: {
    IndexSection,
    TableLikeArea
  },

  data() {
    return {
      infoColumns: [
        { title: '基本信息', labelWidth: 156, data: [] },
        // { title: '内存信息', labelWidth: 156, data: [] },
        // { title: '统计信息', labelWidth: 156, data: [] }
      ],
      connToken: '',
    };
  },

  created() {
    const sourceInfo = ss.get(this.$route.query.db_sign);
    this.connToken = sourceInfo.connToken;
    this.getRedisInfo();
  },

  methods: {
    /**
     * @doc https://mubu.com/doc/1gUfcI5kwc
     */
    async getRedisInfo() {
      try {
        let params = {
          ConnToken: this.connToken
        };
        const { data } = (await reqFetchRedisInfo(params)).data;
        this.procResult(data);
      } catch {
        this.$message.error('获取数据库信息失败');
      }
    },
    getEdition(edition) {
      if(edition === 'SE') {
        return '基础版'
      } else if(edition === 'EE') {
        return '集群版'
      }
    },
    procResult(data){
      this.infoColumns[0].data = [
        [
          { label: '实例名称', value: data.Name },
          { label: '数据库类别', value: this.getEdition(data.ServiceEdition) },
          { label: '数据库版本', value: data.ServiceVersion },
          { label: '端口', value: data.ServicePort },
          { label: '公网IP', value: data.PublicIp },
          { label: '开始时间', value: data.StartTime },
        ],
        [
          { label: '实例ID', value: data.Uuid },
          { label: '数据库类型', value: data.ServiceType },
          { label: '状态', value: (data.StatusDescription === 'running' || data.StatusDescription === 'restart required') ? '运行中' : '异常' },
          { label: '规格', value: data.ServiceEdition==='EE'?data.DbMemory*data.NodeCount+'GB(共'+data.NodeCount+'节点)':data.DbMemory*data.NodeCount+'GB' },
          { label: '内网IP', value: data.HostIp },
          { label: '结束时间', value: data.EndTime }
        ]
      ];
    }
  }
};
</script>

<style scoped lang="scss">
.index {
  padding: 20px;

  .info {
    &-container {
      padding-left: 50px;
      padding-right: 50px;
    }
  }
}
</style>
